module.exports = __webpack_public_path__ + "static/media/file-exel.04102ae3.svg";